export const autofocus = (node) => {
	node.focus();
};

// will disable non-numeric inputs except for backspace, delete, arrow keys and space
export const preventNonNumericInputs = (e) => {
	if (!e?.key) return;
	if (
		(isNaN(e.key) && !['Backspace', 'Delete', 'ArrowRight', 'ArrowLeft'].includes(e.key)) ||
		e.key === ' '
	)
		e.preventDefault();
};

/**
 * flattens every dimension of an array
 * @param {Array<any>} array
 * @returns {Array<any>}
 */
export const deepFlat = function (array) {
	var result = [];

	array.forEach(function (elem) {
		if (Array.isArray(elem)) {
			result = result.concat(deepFlat(elem)); // Fix here
		} else {
			result.push(elem);
		}
	});

	return result;
};

/**
 * rounds a Number with two decimal places
 * @param {number} number
 * @returns {number}
 */
export const round = (number) => Math.round((number + Number.EPSILON) * 100) / 100;

/**
 * Deep compare two objects
 * @param {Object} object1
 * @param {Object} object2
 * @returns {boolean} `boolean`
 */
export const deepEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (const key of keys1) {
		const val1 = object1[key];
		const val2 = object2[key];
		const areObjects = isObject(val1) && isObject(val2);
		if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
			return false;
		}
	}

	return true;
};

export function isObject(object) {
	return object != null && typeof object === 'object';
}

export function sleep(milliseconds) {
	return new Promise((resolve) => {
		setTimeout(resolve, milliseconds);
	});
}

export function getTimeLeft(timestamp) {
	const now = Date.now();
	const diff = timestamp - now;
	const hours = Math.floor(diff / 3_600_000);
	const minutes = Math.floor((diff % 3_600_000) / 60_000);
	return {
		negative: diff < 0,
		time: hours > 0 ? `${hours}h${minutes < 10 ? '0' + minutes : minutes}` : `${minutes}min`
	};
}

export function withDecimal(number) {
	return Math.round(number * 100) / 100;
}

/**
 * evaluate if a string is a valid email or not
 * @param {string} email
 * @returns {boolean}
 */
export const validateEmail = (email) => {
	const mailRegexp = new RegExp(
		/^[\w-\+\.\_]+(\.[\w-\+\.\_]+)*@[\w-\+\.\_]+(\.[\w\+\.\_]+)*(\.[A-Za-z]{2,})$/
	);
	return mailRegexp.test(email);
};

/**
 * evaluate if a string is a valid phone number or not
 * @param {string} phone
 * @returns {boolean}
 */
export const validatePhone = (phone) => {
	const phoneRegexp = new RegExp(/^(\+|00)?(?:[0-9] ?){6,14}[0-9]$/);
	return phoneRegexp.test(phone);
};
